export default {
  ACTIONS: {
    TOGGLE_MENU: 'quickfinder-toggle-menu',
  },
}
